import React from 'react';

import RightArrow from '../../../assets/customSVG/RightArrow';

function AuthBack({ onClick, title }) {
  return (
    <div className="back" onClick={onClick}>
      <RightArrow className="text-[#898E99] text-[10px]" />
      <span className="font-semibold text-[12px] text-[var(--darkgrey)] ml-[7px]">{title}</span>
    </div>
  );
}

export default React.memo(AuthBack);
